module.exports = __webpack_public_path__ + "img/Photo_5__People_&_Pleasures_993_22_2.45e60736.jpg";